/**
 * The orbiting node, in its own overlay layer.
 *
 * Kept out of OrbitMotif deliberately: the node is the only thing that moves,
 * and animating it inside the main drawing would repaint every ellipse and
 * gradient on each frame. Here its repaints touch an almost-empty layer.
 *
 * Shares OrbitMotif's viewBox, so the two line up at any width.
 */
export function OrbitNode() {
  return (
    <svg
      className="orbit-node-layer"
      viewBox="40 100 440 312"
      role="presentation"
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <radialGradient id="nodeFill" cx="34%" cy="30%" r="78%">
          <stop offset="0%" stopColor="#4FD3F2" />
          <stop offset="100%" stopColor="#0090C4" />
        </radialGradient>
      </defs>

      <g transform="rotate(-28 260 260)">
        {/* Positioned by CSS motion path — see hero.css. */}
        <g className="orbit-node">
          <circle r={20} fill="none" stroke="#00B4E7" strokeOpacity={0.4} strokeWidth={1.2} />
          <circle r={10.5} fill="url(#nodeFill)" />
        </g>
      </g>
    </svg>
  );
}
